@if (LOG_METHODS_COLORS[data]) {
<span class="text-color--{{ LOG_METHODS_COLORS[data] }}">{{ data | titlecase }}</span>
} @else {
<gtd-ui-field-empty-component></gtd-ui-field-empty-component>
}
